import { Outlet, ReactLocation, Route, Router } from '@tanstack/react-location';
import { ErrorPage400 } from './components/ErrorPage400';
import { LocationGenerics, MainRoute, FormsParam, OnlineSchedulerDigitalFormsParam } from './types/routing.types';

import { DigitalFormsMain } from '../components/DigitalForms/DigitalFormsMain';
import { OnlineSchedulerDigitalFormsMain } from '../components/OnlineSchedulerDigitalForms/OnlineSchedulerDigitalFormsMain';
import { ErrorPage403 } from './components/ErrorPage403';
const location = new ReactLocation<LocationGenerics>();

export const MainRouter = () => {
  const routes: Route<LocationGenerics>[] = [
    {
      path: OnlineSchedulerDigitalFormsParam.uuid,
      element: <OnlineSchedulerDigitalFormsMain />,
    },
    {
      path: FormsParam.uuid,
      element: <DigitalFormsMain />,
    },
    {
      path: MainRoute.Root,
      element: <ErrorPage400 />,
    },
    {
      path: MainRoute.Error400,
      element: <ErrorPage400 />,
    },
    {
      path: MainRoute.Error403,
      element: <ErrorPage403 />,
    },
    {
      path: MainRoute.Any,
      element: <ErrorPage400 />,
    },
  ];
  return (
    <Router<LocationGenerics> location={location} defaultPendingMs={0} defaultPendingMinMs={300} defaultLinkPreloadMaxAge={1000} routes={routes}>
      <Outlet />
    </Router>
  );
};
